// extracted by mini-css-extract-plugin
export default {"footerSection":"Footer_footerSection__Jly2Y","footerHighlightText":"Footer_footerHighlightText__jlZTS","footerTrademarkText":"Footer_footerTrademarkText__3LX1E"};